<template>
  <span>{{ assigneeName }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { ApplicationDueTask } from "@/models/applications";

const { value } = defineProps<{
  value: ApplicationDueTask["assignee"] | null;
}>();

const assigneeName = computed(() => value?.full_name ?? "-");
</script>
